import _ from "lodash";

export const BOOKS_STR =
  "លោកុប្បត្តិ,និក្ខមនំ,លេវីវិន័យ,ជនគណនា,ទុតិយកថា,យ៉ូស្វេ,ចៅហ្វាយ,នាង​រស់,១ សាំយូអែល,២ សាំយូអែល,១ ពង្សាវតារក្សត្រ,២ ពង្សាវតារក្សត្រ,១ របាក្សត្រ,២ របាក្សត្រ,អែសរ៉ា,នេហេមា,នាង​អេសធើរ,យ៉ូប,ទំនុកតម្កើង,សុភាសិត,សាស្ដា,បទ​ចំរៀង,អេសាយ,យេរេមា,បរិទេវ,អេសេគាល,ដានីយ៉ែល,ហូសេ,យ៉ូអែល,អេម៉ុស,អូបាឌា,យ៉ូណាស,មីកា,ណាហ៊ូម,ហាបាគូក,សេផានា,ហាកាយ,សាការី,ម៉ាឡាគី,ម៉ាថាយ,ម៉ាកុស,លូកា,យ៉ូហាន,កិច្ចការ,រ៉ូម,១ កូរិនថូស,២ កូរិនថូស,កាឡាទី,អេភេសូ,ភីលីព,កូឡូស,១ ថេស្សាឡូនិក,២ ថេស្សាឡូនិក,១ ធីម៉ូថេ,២ ធីម៉ូថេ,ទីតុស,ភីលេម៉ូន,ហេប្រឺ,យ៉ាកុប,១ ពេត្រុស,២ ពេត្រុស,១ យ៉ូហាន,២ យ៉ូហាន,៣ យ៉ូហាន,យូដាស,វិវរណៈ";
export const BOOKS_ARR = [
  "លោកុប្បត្តិ",
  "និក្ខមនំ",
  "លេវីវិន័យ",
  "ជនគណនា",
  "ទុតិយកថា",
  "យ៉ូស្វេ",
  "ចៅហ្វាយ",
  "នាង​រស់",
  "១ សាំយូអែល",
  "២ សាំយូអែល",
  "១ ពង្សាវតារក្សត្រ",
  "២ ពង្សាវតារក្សត្រ",
  "១ របាក្សត្រ",
  "២ របាក្សត្រ",
  "អែសរ៉ា",
  "នេហេមា",
  "នាង​អេសធើរ",
  "យ៉ូប",
  "ទំនុកតម្កើង",
  "សុភាសិត",
  "សាស្ដា",
  "បទ​ចំរៀង",
  "អេសាយ",
  "យេរេមា",
  "បរិទេវ",
  "អេសេគាល",
  "ដានីយ៉ែល",
  "ហូសេ",
  "យ៉ូអែល",
  "អេម៉ុស",
  "អូបាឌា",
  "យ៉ូណាស",
  "មីកា",
  "ណាហ៊ូម",
  "ហាបាគូក",
  "សេផានា",
  "ហាកាយ",
  "សាការី",
  "ម៉ាឡាគី",
  "ម៉ាថាយ",
  "ម៉ាកុស",
  "លូកា",
  "យ៉ូហាន",
  "កិច្ចការ",
  "រ៉ូម",
  "១ កូរិនថូស",
  "២ កូរិនថូស",
  "កាឡាទី",
  "អេភេសូ",
  "ភីលីព",
  "កូឡូស",
  "១ ថេស្សាឡូនិក",
  "២ ថេស្សាឡូនិក",
  "១ ធីម៉ូថេ",
  "២ ធីម៉ូថេ",
  "ទីតុស",
  "ភីលេម៉ូន",
  "ហេប្រឺ",
  "យ៉ាកុប",
  "១ ពេត្រុស",
  "២ ពេត្រុស",
  "១ យ៉ូហាន",
  "២ យ៉ូហាន",
  "៣ យ៉ូហាន",
  "យូដាស",
  "វិវរណៈ",
].concat([
  // add some alt spellings that Google might send
  "១ ពង្សាវតាក្សត្រ",
  "២ ពង្សាវតាក្សត្រ",
]);

const _nums = ["១", "២", "៣"];
// TODO for performance don't run all this stuff on initialization, do it when it's called or
// something
// all the books that have more than one
export const BOOKS_WITH_MANY = BOOKS_ARR.filter((b) => _nums.includes(b[0]));
// take away the number for them
export const BOOKS_WITH_MANY_NO_NUM = _.uniq(
  BOOKS_WITH_MANY.map((b) => b.substring(2))
);
export const ALL_BOOKS_NO_NUM = _.uniq(
  BOOKS_ARR.map((b) => {
    if (BOOKS_WITH_MANY.includes(b)) {
      return b.substring(2);
    } else {
      return b;
    }
  })
);
